import { createSlice } from "@reduxjs/toolkit";
import { greatNonProfitAPI } from "../../../api/publicApi";

const data = {
  isLoading: false,
  error: "",
  message: null,
  data: null,
};

const greatNonProfitSlice = createSlice({
  name: "greatNonProfit",
  initialState: data,
  reducers: {
    greatNonProfitSlice(state) {
      state.isLoading = false;
    },
    greatNonProfitSliceSuccess(state, action) {
      state.isLoading = true;
      state.data = action.payload;
      state.message = null;
    },
    greatNonProfitSliceFailure(state, action) {
      state.isLoading = false;
      state.message = action.payload;
    },
    greatNonProfitSliceReset(state) {
      state.isLoading = false;
      state.message = null;
      state.data = null;
      state.error = "";
    },
  },
});

export const greatNonProfitHandler = () => async (dispatch: any) => {
  try {
    dispatch(greatNonProfitAction.greatNonProfitSlice());
    const response: any = await greatNonProfitAPI();
    dispatch(greatNonProfitAction.greatNonProfitSliceSuccess(response));
  } catch (e: any) {
    dispatch(greatNonProfitAction.greatNonProfitSliceFailure(e?.response?.data?.message));
    dispatch(greatNonProfitAction.greatNonProfitSliceReset());
  }
};
export default greatNonProfitSlice.reducer;
export const greatNonProfitAction = greatNonProfitSlice.actions;
